import { CRON_SECRET } from '../config/env';
import { serviceRoleClient } from './serviceRoleClient';

/** Service-role client for marketing-site tables (blog, keywords, website_leads). */
export const marketingAdmin = serviceRoleClient;

export const MARKETING_SITE_URL =
  process.env.REACT_APP_MARKETING_SITE_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3010' : 'https://app.roadserve.in');

export function marketingBlogPostUrl(slug, status = 'published') {
  const base = MARKETING_SITE_URL;
  if (status === 'draft') {
    return `${base}/blog/${slug}?preview=1`;
  }
  return `${base}/blog/${slug}`;
}

/**
 * Blog generate/cover APIs live under /api/cron/* on the marketing site.
 * Dev: CRA proxy `/api/marketing` → localhost:3010/api (avoids CORS).
 * Prod: call https://app.roadserve.in/api/... directly (CORS allows roadserve.astric.ai).
 */
export const MARKETING_API_BASE =
  process.env.NODE_ENV === 'development'
    ? '/api/marketing'
    : `${String(MARKETING_SITE_URL).replace(/\/$/, '')}/api`;

export function marketingAdminAuthHeader() {
  return { Authorization: `Bearer ${CRON_SECRET || SUPABASE_SERVICE_ROLE_KEY}` };
}

export function marketingGenerateBlogUrl() {
  return `${MARKETING_API_BASE}/cron/generate-blog`;
}

export function marketingGenerateWaTemplateUrl() {
  return `${MARKETING_API_BASE}/cron/generate-wa-template`;
}

export function marketingRegenerateCoverUrl() {
  return `${MARKETING_API_BASE}/cron/regenerate-cover`;
}

export function marketingShortLinkUrl(code) {
  const base = MARKETING_SITE_URL.replace(/\/$/, '');
  return `${base}/go/${encodeURIComponent(String(code || '').trim().toLowerCase())}`;
}
